import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "8",
  height: "12",
  viewBox: "0 0 8 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.41 1.7925L6 0.5L0 6L6 11.5L7.41 10.2075L2.83 6L7.41 1.7925Z",
      fill: "currentColor",
      "fill-opacity": "0.87"
    }, null, -1)
  ]))]))
}
export default { render: render }